<template>
  <div class="container">
    <div class="main-banner-top">
      <!-- <BannerOpacity> -->


      <div class="old-clients">
        <!--
        <div class="modal-content" style="max-width: 800px; margin: 0 auto; padding: 1rem; font-size: 1.2rem; color: red; font-weight: 700;">
          <p>W dniach 12-13 grudnia 2023 (wtorek i środa) hurtownia VETdirect będzie nieczynna z powodu inwentaryzacji.</p>
          <p>Zamówienia złożone w poniedziałek 11 grudnia do godziny 12:40 realizowane będą tego samego dnia.<br/>
          Zamówienia złożone w poniedziałek 11 grudnia po godzinie 12:40 realizowane będą w czwartek 14 grudnia.<br/>
            Zamówienia złożone we wtorek oraz środę, tj. 12 i 13 grudnia realizowane będą w czwartek 14 grudnia.</p>
          <p>Przepraszamy za utrudnienia.</p>
        </div>
        --->
        <div class="modal-content" style="max-width: 800px; margin: 0 auto; padding: 1rem; font-size: 1.2rem; color: red; font-weight: 700;">
          <p>Uwaga! W najbliższy czwartek i piątek (1 i 2 maja 2025) Hurtownia będzie nieczynna!</p>
          <p>Zamówienia złożone przez platformę w środę 30.04 do godziny 12:30 będą realizowane w ten sam dzień, <br>
            a złożone po godzinie 12:30 będą realizowane w poniedziałek 5 maja.</p>
          <p>Przepraszamy za utrudnienia.</p>
        </div>

        <h3 class="form-title form-title--old">DLA STAŁYCH KLIENTÓW</h3>
        <div class="main-page-wrapper">
          <SingInPage class="main-panel-sign-in" />
        </div>
      </div>

      <div class="new-clients">
        <h3 class="form-title form-title--new">DLA NOWYCH KLIENTÓW</h3>
        <BeforeLoginContact />
      </div>
      <!-- </BannerOpacity> -->
    </div>
  </div>

  <!-- <Page class="main-page-template" type="MAINPAGE" /> -->
  <!-- <ContactForm /> -->
</template>

<script>
import {
  SingInPage,
  BannerOpacity,
  Page,
  ContactForm
} from "../RedbayComponents";
import BeforeLoginContact from "./VetDirectBeforeLoginContact";

export default {
  components: {
    SingInPage,
    BannerOpacity,
    Page,
    ContactForm,
    BeforeLoginContact
  },
  beforeMount() {
    if (this.$store.state.user.authorizedUser) {
      this.$router.replace({ name: "welcomePage" });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/MainPage.vue